export const muscles = [
    {
        group: "Chest",
        value: "chest"
    },
    {
        group: "Back",
        value: "back"
    },
    {
        group: "Legs",
        value: "legs"
    },
    {
        group: "Biceps",
        value: "biceps"
    },
    {
        group: "Triceps",
        value: "triceps"
    },
    {
        group: "Shoulders",
        value: "shoulders"
    },
]

export const exercises = [
    {
        group: "chest",
        name: ["Bench press", "Dumbbell press at an angle of 45", "Crossover from above", "Crossover from below"]
    },
    {
        group: "back",
        name: ["Vertical thrust", "Horizontal thrust", "Pull-ups with extra weight", "T-bar traction", "Shrag with dumbbells"]
    },
    {
        group: "legs",
        name: ["Leg press", "Squats ", "Stretching legs", "Bending the legs ", "Deadlift"]
    },
    {
        group: "biceps",
        name: ["Bending the arms with a straight barbell", "Bending the arms with a Z-bar", "Hammers with dumbbells"]
    },
    {
        group: "triceps",
        name: ["Press lying down with a narrow grip", "Stretching the barbell behind the head", "Extension in the block", "Stretching arms with dumbbells at an angle"]
    },
    {
        group: "shoulders",
        name: ["Dumbbell bench press while sitting", "Thrust barbell at an angle"]
    }
]